export const decisioningStudioAgentsConsumption =
  "/analytics_dashboard/:app_group_id/decisioning_studio_agents_credit_consumption_detail_data";
